import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import workerAPI from './api/workerAPI'; // ✅ adjust path if needed

import CompanyRegsiter from './Components/CompanyRegister'
import CompanySignup from './Components/CompanySignup';
import AdminLogin from './Components/AdminLogin';
import AdminNavbar from './Components/AdminNavbar';
import AddWorkers from './Components/AddWorkers';
import UserLogin from './Components/UserLogin'
import AdminProfile from './Components/AdminProfile';
import UserDashboard from './Components/UserDashboard';
import UserProfile from './Components/UserProfile';
import WelcomePage from './Components/WelcomePage';
import AdminLeaveReport from './Components/AdminLeaveReport';
import AdminAttendance from './Components/AdminAttendance';
import AdminTaskManager from './Components/AdminTask';
import AdminProject from './Components/AdminProject';
import WorkerLeaveReport from './Components/WorkerLeaveReport';
import WorkerTask from './Components/WorkerTask';
import WorkerProjectTracking from './Components/WorkerProject';
import WorkerFace from './Components/WorkerFace';
import FaceRegistration from './Components/FaceRegistration';
import WorkerAttendance from './Components/WorkerAttendance';
import AdminLocation from './Components/AdminLocation';
import LocationTrack from './Components/LocationTrack';
import LiveLocationDashboard from './Components/LiveLocationDashboard';
import CompanyLogin from './Components/CompanyLogin';
import AdminOverview from './Components/AdminOverview';
import AdminVoiceChat from './Components/AdminVoiceChat';
import AdminReport from './Components/AdminReport';
import AdminMarketingReports from './Components/AdminMarketingReports';
import AdminMarketingLocation from './Components/AdminMarketingLocation';

import OfficeAttendance from './Components/OfficeAttendance';
import OfficeLeave from './Components/OfficeLeave';
import OfficeTask from './Components/OfficeTask';
import OfficeProject from './Components/OfficeProject';
import OfficeLiveLocation from './Components/OfficeLiveLocation';
import OfficeProfile from './Components/OfficeProfile';
import MyAttendance from './Components/MyAttendance';


import TeamAttendance from './Components/TeamAttendance';
import TeamLeave from './Components/TeamLeave';
import TeamTask from './Components/TeamTask';
import TeamProject from './Components/TeamProject';



import FaceWatcher from './Components/FaceWatcher';
import WorkerDashboard from './Components/WorkerDashboard';
import VoiceChat from './Components/VoiceChat';

import MarketingDashboard from './Components/MarketingDashboard';
import AdminAssignedLocations from './Components/adminviewmarktask';
import MarketingMembers from './Components/MarketingMembers';
import LiveLocationDashboardmyo from './Components/myolocatrack';
import AdminAttendancemyo from './Components/myoattendance';
import LeaveReportmyo from './Components/myoleave';
import AdminAssignedLocationsmyo from './Components/myoviewtask';
import CompanyWorkersReports from './Components/displayhomepeople';
import WorkerReportsView from './Components/displayhomereport';
import MarketingTaskManager from './Components/MarketingAssignTask';
import TaskFileUpload from './Components/Taskfileupload';
import PLTaskManager from './Components/PlTaskManager';
import TlTaskManager from './Components/TlTaskManager';
import WorkerProjectView from './Components/workerProjectview';
import MarketingProjectManager from './Components/MarketingProjectmanager';
import PLProjectManager from './Components/plProjectmanager';
import MarketingMemberslc from './Components/AdminMarkmem';
import HRDesignTaskManager from './Components/HrTaskAssign';

let isWorker = false;
const token = localStorage.getItem('token');
if (token) {
  try {
    const decoded = jwtDecode(token);
    isWorker = !!decoded.workerId;
  } catch (err) {
    console.warn("Invalid token format");
  }
}

function App() {
  
useEffect(() => {
  const setOffline = () => {
   navigator.sendBeacon(
  "https://missionmap-lc.onrender.com/api/attendance/status",
  JSON.stringify({
    status: "offline",
    workerId: localStorage.getItem("workerId")
  })
);
  };

  window.addEventListener("beforeunload", setOffline);

  return () => {
    window.removeEventListener("beforeunload", setOffline);
  };
}, []);
useEffect(() => {
  // Only run for logged-in workers, not admin
  const worker = JSON.parse(localStorage.getItem('worker'));
  const token  = localStorage.getItem('token');
  if (!worker || !token) return;

  let idleTimer = null;
  let lastStatus = null; // prevent duplicate API calls

  const updateStatus = async (status) => {
    if (status === lastStatus) return; // skip if already in this state
    lastStatus = status;
    try {
      await workerAPI.patch('/status', { status });
    } catch (err) {
      console.error('Status update failed', err);
    }
  };

  const resetTimer = () => {
    clearTimeout(idleTimer);
    updateStatus('online'); // only fires when status actually changes
    idleTimer = setTimeout(() => {
      updateStatus('idle');
    }, 5 * 60 * 1000); // 5 min no activity → idle
  };

  // Set online immediately
  updateStatus('online');
  resetTimer();

  window.addEventListener('mousemove', resetTimer);
  window.addEventListener('keydown',   resetTimer);
  window.addEventListener('click',     resetTimer);

  // Mark offline on tab/browser close
  const handleUnload = () => {
    const w = JSON.parse(localStorage.getItem('worker'));
    if (w?._id) {
      const blob = new Blob(
        [JSON.stringify({ workerId: w._id })],
        { type: 'application/json' }
      );
      navigator.sendBeacon(
        `${import.meta.env.VITE_API_URL || 'https://missionmap-lc.onrender.com'}/api/attendance/offline`,
        blob
      );
    }
  };
  window.addEventListener('beforeunload', handleUnload);

  return () => {
    clearTimeout(idleTimer);
    window.removeEventListener('mousemove',    resetTimer);
    window.removeEventListener('keydown',      resetTimer);
    window.removeEventListener('click',        resetTimer);
    window.removeEventListener('beforeunload', handleUnload);
  };
}, []);

  return (
    
    <>
      {isWorker && <LocationTrack />} 

    <Router>
      <Routes>
        <Route path='/company-login' element={<CompanyLogin />} />
        <Route path='/company-register' element={<CompanyRegsiter />} />
        <Route path="/signup" element={<CompanySignup />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/navbar" element={<AdminNavbar />} />
        <Route path="/add-workers" element={<AddWorkers />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/admin-profile" element={<AdminProfile />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="/" element={<WelcomePage />} />
        <Route path="/leave-report" element={<AdminLeaveReport />} />
        <Route path="/attendance" element={<AdminAttendance />} />
        <Route path="/tasks" element={<AdminTaskManager />} />
       
 
        <Route path="/task-overview" element={<AdminTaskManager />} />
        <Route path="/projects" element={<AdminProject />} />
        <Route path="/overview" element={<AdminOverview />} />
        <Route path="/admin-voice" element={<AdminVoiceChat />} />
        <Route path="/admin-report" element={<AdminReport />} />
        
        <Route path="/user-leave" element={<WorkerLeaveReport />} />
        <Route path="/user-tasks" element={<WorkerTask />} />
        <Route path="/user-projectss" element={<WorkerProjectTracking />} />
        <Route path="/register" element={<FaceRegistration />} />
        <Route path="/user-face" element={<WorkerFace />} />
        <Route path="/user-attendance" element={<WorkerAttendance />} />
        <Route path="/location" element={<AdminLocation />} />
        <Route path="/live-location" element={<LiveLocationDashboard />} />


        <Route path="/office-attendance" element={<OfficeAttendance />} />
        <Route path="/hr-team-attendance" element={<OfficeAttendance />} />
        <Route path="/office-leave" element={<OfficeLeave />} />
        <Route path="/office-tasks" element={<OfficeTask />} />
        <Route path="/office-projects" element={<OfficeProject />} />
        <Route path="/office-live-location" element={<OfficeLiveLocation />} />
        <Route path="/office-profile" element={<OfficeProfile />} />
        <Route path="/my-attendance" element={<MyAttendance />} />


        <Route path="/team-attendance" element={<TeamAttendance />} />
        <Route path="/team-leave" element={<TeamLeave />} />
        <Route path="/team-tasks" element={<TeamTask />} />
        <Route path="/team-projects" element={<TeamProject />} />


        <Route path="/face-watcher" element={<FaceWatcher />} />
        <Route path='*' element={<WorkerDashboard />} />
        <Route path="/voice-chat" element={<VoiceChat />} />
        <Route path="/marketing-dashboard" element={<MarketingDashboard />} />
        <Route path="/marketing-reports/:memberId" element={<AdminMarketingReports />} />
        <Route path="/marketing-livelocation" element={<AdminMarketingLocation />} />
        <Route path="/admin/assigned-locations" element={<AdminAssignedLocations />} />
        <Route path="/marketing-members" element={<MarketingMembers />} />
          <Route path="/myo-live-location" element={<LiveLocationDashboardmyo />} />
          <Route path="/myo-attendance" element={<AdminAttendancemyo />} />
          <Route path="/myo-leave" element={<LeaveReportmyo />} />
          <Route path="/myo-assigned-locations" element={<AdminAssignedLocationsmyo />} />
          <Route path="/company-workers" element={<CompanyWorkersReports />} />
          <Route path="/worker-reports" element={<WorkerReportsView />} />
          <Route path="/marketing-assign-task" element={<MarketingTaskManager />} />
          <Route path="/task-file-upload" element={<TaskFileUpload />} />
          <Route path="/pl-task-manager" element={<PLTaskManager />} />
          <Route path="/tl-task-manager" element={<TlTaskManager />} />
          <Route path="/user-projects"   element={<WorkerProjectView />} />
          <Route path="/marketing-projects" element={<MarketingProjectManager />} />
          <Route path="/pl-projects"        element={<PLProjectManager />} />
            <Route path="/marketing-members-ad" element={<MarketingMemberslc />} /> 
            <Route path="/hr-design-task-manager" element={<HRDesignTaskManager />} />  
       


      </Routes>
    </Router>
    </>
  );
}

export default App;
